import React from 'react';

/**
 * Barra de botões padrão do sistema.
 *
 * Props de atalho CRUD (renderizam os botões internamente):
 *   onNew        – handler do botão Novo (verde)
 *   onEdit       – handler do botão Editar (amarelo)
 *   disableEdit  – boolean que desabilita Editar
 *   onDelete     – handler do botão Excluir (vermelho)
 *   disableDelete – boolean que desabilita Excluir
 *
 * Qualquer `children` é colocado após os botões CRUD.
 * Quando há children E botões CRUD, um separador visual é inserido entre eles.
 *
 * Classe base: botao-grid-2col. Margem padrão: mb-3.
 * Use a prop `className` para sobrescrever ou adicionar classes extras.
 */
const Toolbar = ({
  children,
  className = 'mb-2',
  style,
  onNew,
  onEdit,
  disableEdit = false,
  onDelete,
  disableDelete = false,
}) => {
  const hasStdButtons = onNew || onEdit || onDelete;
  const hasChildren = React.Children.count(children) > 0;
  const stdButtonCount = [onNew, onEdit, onDelete].filter(Boolean).length;

  return (
    <div
      className={['botao-grid-2col', className].filter(Boolean).join(' ')}
      style={style}
    >
      {onNew && (
        <button
          type="button"
          className="btn btn-success btn-sm botao-igual"
          onClick={onNew}
        >
          <i className="bi bi-plus-lg me-1" />Novo
        </button>
      )}
      {onEdit && (
        <button
          type="button"
          className="btn btn-warning btn-sm botao-igual"
          onClick={onEdit}
          disabled={disableEdit}
        >
          <i className="bi bi-pencil me-1" />Editar
        </button>
      )}
      {onDelete && (
        <button
          type="button"
          className={`btn btn-danger btn-sm botao-igual${stdButtonCount % 2 === 1 ? ' centralizar-se-impar' : ''}`}
          onClick={onDelete}
          disabled={disableDelete}
        >
          <i className="bi bi-trash me-1" />Excluir
        </button>
      )}
      {hasStdButtons && hasChildren && <span className="toolbar-separator" />}
      {children}
    </div>
  );
};

export default Toolbar;

